<template>
  <pt-doctor-detail class="pt-doctor-detail__page"></pt-doctor-detail>
</template>

<script>
import PtDoctorDetail from 'cps/hospital-and-doctor-manage/pt-doctor-manage/pt-doctor-detail/withData'
export default {
  name: 'pt-doctor-detail__view',
  components: {
    'pt-doctor-detail': PtDoctorDetail
  }
}
</script>
